import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import 'bootstrap'
import store from './store'
import App from './App.vue'
import VueCustomElement from "vue-custom-element";

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueCustomElement)

// Widget
let widgetNode = process.env.VUE_APP_WIDGET_NODE
var nodes = document.getElementsByTagName(widgetNode)

// APP settings
App.router = router
App.store = store

nodes.forEach(() => {
  Vue.customElement(widgetNode, App)
})